import React from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import CustomButton from '../../../../components/General/CustomButton';
import useStyles from './styles';

interface DeleteConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  programName: string;
  loading?: boolean;
}

function DeleteConfirmModal({
  open,
  onClose,
  onConfirm,
  programName,
  loading = false,
}: DeleteConfirmModalProps) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={classes.modalContainer}>
        <Card className={classes.modal}>
          <CardContent className={classes.modalContent}>
            <Box className={classes.modalTitleContainer}>
              <Box className={classes.modalTitleAndIcon}>
                <Typography variant="h4" color="primary" fontWeight="bold">
                  Eliminar programa
                </Typography>
              </Box>
              <IconButton onClick={onClose} disabled={loading}>
                <CloseIcon color="primary" />
              </IconButton>
            </Box>
            <Box className={classes.modalDeleteBody}>
              <Typography variant="body1" textAlign="center">
                ¿Estás seguro de que deseas eliminar el programa <strong>{programName}</strong>?
              </Typography>
            </Box>
            <Box className={classes.modalButtonsContainer}>
              <CustomButton
                text="Cancelar"
                colorType="tertiary"
                onClick={onClose}
                disabled={loading}
                icon={<CloseIcon />}
              />
              <CustomButton
                text="Eliminar"
                colorType="primary"
                onClick={onConfirm}
                disabled={loading}
                loading={loading}
                icon={<DeleteIcon />}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
}

export default DeleteConfirmModal;
